import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'apps/shared/scripts/components';

import { primaryButtonClassName } from './styles';

interface Props {
  hideMenu: () => void;
}

const CreateCardButton = ({ hideMenu }: Props) => {
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    hideMenu();
    navigate('/dashboard/create');
  }, [hideMenu, navigate]);

  return (
    <Button
      className={primaryButtonClassName}
      faIcon={faPlus}
      onClick={onClick}
      fullWidth
    >
      Create Card
    </Button>
  );
};

CreateCardButton.displayName = 'CreateCardButton';

export default CreateCardButton;
